document.addEventListener("DOMContentLoaded", () => {
    // Create the Scroll to Top button
    const scrollToTopBtn = document.createElement("button");
    scrollToTopBtn.id = "fb-scroll-to-top";
    scrollToTopBtn.innerHTML = `
        <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 6L6 1M6 1L11 6M6 1V13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
    `;
    document.body.appendChild(scrollToTopBtn);

    // Show/hide button on scroll
    window.addEventListener("scroll", () => {
        if (window.scrollY > 300) {
            scrollToTopBtn.classList.add("visible");
        } else {
            scrollToTopBtn.classList.remove("visible");
        }
    });

    // Smooth scroll to top on click
    scrollToTopBtn.addEventListener("click", () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    });
});
